import React from "react";
import InternalHeader from "../internal-header";
import { Badge, Breadcrumb } from "flowbite-react";
import { Link } from "react-router-dom";
import { HiOutlineQuestionMarkCircle } from "react-icons/hi2";
import { Tooltip } from "flowbite-react";

const ChildNode = (props) => {
  return React.Children.map(props.children, (child) => {
    // checking isValidElement is the safe way and avoids a typescript error too
    const childProps = {};
    if (React.isValidElement(child)) {
      return React.cloneElement(child, childProps);
    }
    return child;
  });
};

export default function Index(props) {
  const {
    title,
    subtitle,
    headerAction,
    navigation,
    navigationPosition = "above-header",
    breadcrumbNav,
    titleMarker,
    titleMarkerColor = "success",
    tooltip,
  } = props;
  return (
    <div className="h-full bg-panel">
      {navigationPosition === "above-header" && navigation && navigation.length > 0 && (
        <InternalHeader navigation={navigation} />
      )}

      <div className="mx-auto px-6 pt-6">
        {breadcrumbNav && breadcrumbNav.length > 0 && (
          <div className="pb-4">
            <Breadcrumb aria-label="breadcrumb">
              {breadcrumbNav.map((nav) => (
                <Breadcrumb.Item key={nav.href} href="#">
                  <Link
                    className="text-sm text-muted transition-colors hover:text-ink"
                    to={nav.href}
                  >
                    {nav.name}
                  </Link>
                </Breadcrumb.Item>
              ))}
            </Breadcrumb>
          </div>
        )}

        <div className="flex flex-row items-center gap-2 px-0">
          {title && (
            <>
              <h1 className="text-xl font-semibold tracking-tight text-ink xl:text-2xl">
                {title}
              </h1>
              {tooltip && (
                <Tooltip className="z-50" content={tooltip}>
                  <HiOutlineQuestionMarkCircle className="h-5 w-5 text-muted transition-colors hover:text-ink/80" />
                </Tooltip>
              )}
            </>
          )}

          {titleMarker && (
            <div className="flex flex-row items-center">
              <Badge color={titleMarkerColor}>{titleMarker}</Badge>
            </div>
          )}

          {headerAction && (
            <div className="flex flex-auto items-center justify-end gap-2">
              {headerAction}
            </div>
          )}
        </div>

        {subtitle && (
          <p className="pt-1.5 pb-6 text-sm text-muted">
            {subtitle}
          </p>
        )}
        {navigationPosition === "below-header" && navigation && navigation.length > 0 && (
          <div className={`-mx-6 mb-6 ${subtitle ? "" : "mt-6"}`}>
            <InternalHeader navigation={navigation} />
          </div>
        )}
        <div className={`max-height-wrapper px-0 ${subtitle ? "" : "pt-6"}`}>
          <ChildNode>{props.children}</ChildNode>
        </div>
      </div>
    </div>
  );
}
